var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isSubmit)?_c('GetInfo',{attrs:{"channel":_vm.channel,"operationCode":_vm.operationCode},on:{"updateIsSubmit":_vm.updateIsSubmit}}):_c('GetInfoSuccessed',{attrs:{"channel":_vm.channel}})}
var staticRenderFns = []

export { render, staticRenderFns }